import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Button from 'Components/UI/Button';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.dark,
  },
  downloadButton: {
    marginTop: theme.spacing(2),
  },
});

const Downloadable = ({
  classes,
  className,
  fileName,
  href,
}) => {
  return (
    <Box className={classNames(classes.download, className)}>
      <Typography component="div" variant="h6">
        {'File Downloadable is not supported for this file type. Please download'}
      </Typography>
      <Link
        href={href}
        className={classes.disableLinkStyle}
        title={`Download ${fileName}`}
        rel="noopener noreferrer"
        download={fileName}
      >
        <Button
          className={classes.downloadButton}
          color="primary"
          variant="contained"
          startIcon={<GetAppIcon />}
        >
          {`Download ${fileName}`}
        </Button>
      </Link>
    </Box>
  );
};


Downloadable.defaultProps = {
  className: '',
};


Downloadable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default withStyles(styles)(Downloadable);
